/* Maithri theme — vanilla JS: sparks, tilt, reveals, needs switcher, product form, AJAX cart drawer, Ivory/Sanctum switch */
(function () {
  'use strict';
  var M = window.Maithri || {};
  var FX = Object.assign({ sparks: true, density: 90, palette: 'lotus', tilt: 2, motion: true }, M.fx || {});
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) FX.motion = false;
  M.fx = FX;
  if (M.designMode) document.documentElement.classList.add('shopify-design-mode');
  if (!FX.motion) document.body.classList.add('fx-still');

  /* ---------------- Money ---------------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = M.moneyFormat || '₹{{amount}}';
    function delim(n, prec, thou, dec) {
      var s = (n / 100).toFixed(prec), parts = s.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delim(cents, 2, "'", '.'); break;
      default: out = delim(cents, 2, ',', '.');
    }
    out = out.replace(/[.,]00$/, '');
    var tmp = document.createElement('div');
    tmp.innerHTML = fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
    return tmp.textContent;
  }
  M.formatMoney = formatMoney;

  /* ---------------- Sparks ---------------- */
  var PAL = {
    gold: ['#c0994b', '#d8b777', '#e8d29c', '#a47f36'],
    diya: ['#e0a33e', '#ffcf7a', '#c0994b', '#e55203'],
    intentions: ['#c0994b', '#02783e', '#cf0260', '#7e3b99', '#e55203'],
    lotus: ['#e98aa6', '#c0994b', '#f3c6d3', '#d8b777']
  };
  var sprites = {};
  function sprite(color) {
    if (sprites[color]) return sprites[color];
    var c = document.createElement('canvas'); c.width = c.height = 64;
    var x = c.getContext('2d'), g = x.createRadialGradient(32, 32, 0, 32, 32, 32);
    g.addColorStop(0, '#fffaf0'); g.addColorStop(0.18, color);
    g.addColorStop(0.45, color + '55'); g.addColorStop(1, color + '00');
    x.fillStyle = g; x.fillRect(0, 0, 64, 64);
    return (sprites[color] = c);
  }
  function drawStar(ctx, x, y, r, color, a) {
    ctx.save(); ctx.globalAlpha = a; ctx.fillStyle = color; ctx.translate(x, y); ctx.beginPath();
    for (var i = 0; i < 4; i++) { ctx.rotate(Math.PI / 2); ctx.moveTo(0, 0); ctx.quadraticCurveTo(r * 0.18, r * 0.18, r * 2.6, 0); ctx.quadraticCurveTo(r * 0.18, -r * 0.18, 0, 0); }
    ctx.fill(); ctx.restore();
  }

  function SparkField(cv) {
    var mode = cv.getAttribute('data-spark') || 'ambient';
    var scale = parseFloat(cv.getAttribute('data-scale') || '1');
    var host = mode === 'burst' ? cv.parentElement : cv.parentElement;
    var ctx = cv.getContext('2d');
    var w = 0, h = 0, t = 0, P = [], mouse = { x: -9999, y: -9999 }, running = false, visible = true;
    var active = true;
    if (cv.getAttribute('data-trigger') === 'card') {
      active = false;
      var card = cv.closest('.pcard');
      if (card) {
        card.addEventListener('pointerenter', function () { active = true; tick(); });
        card.addEventListener('pointerleave', function () { active = false; });
      }
    }
    function resize() {
      var r = host.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
      w = r.width; h = r.height; cv.width = Math.max(1, w * d); cv.height = Math.max(1, h * d); ctx.setTransform(d, 0, 0, d, 0, 0);
    }
    if (window.ResizeObserver) new ResizeObserver(resize).observe(host); else window.addEventListener('resize', resize);
    resize();
    if ('IntersectionObserver' in window && mode !== 'burst') {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) tick(); }, { rootMargin: '50px' }).observe(host);
    }
    function pal() { return PAL[FX.palette] || PAL.gold; }
    function spawn(x, y, burst) {
      var c = pal(), r = Math.random(), ang = Math.random() * Math.PI * 2, sp = 1.5 + Math.random() * 4.5;
      P.push({
        x: x != null ? x : Math.random() * w,
        y: y != null ? y : (mode === 'hover' ? h * (0.4 + Math.random() * 0.6) : h + 10),
        vx: burst ? Math.cos(ang) * sp : (Math.random() - 0.5) * 0.3,
        vy: burst ? Math.sin(ang) * sp - 1.2 : -(0.25 + Math.random() * (mode === 'hover' ? 1.1 : 0.7)),
        life: 0, max: burst ? 50 + Math.random() * 50 : (mode === 'hover' ? 70 + Math.random() * 60 : 260 + Math.random() * 320),
        r: (0.8 + r * r * 2.6) * scale, star: Math.random() < (burst ? 0.4 : 0.16), c: c[(Math.random() * c.length) | 0],
        ph: Math.random() * 6.28, burst: burst, glow: 0
      });
    }
    if (mode === 'ambient') for (var i = 0; i < 40; i++) { spawn(Math.random() * w, Math.random() * h); P[P.length - 1].life = Math.random() * 200; }

    if (mode !== 'burst') {
      host.addEventListener('pointermove', function (e) { var r = cv.getBoundingClientRect(); mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top; });
      host.addEventListener('pointerleave', function () { mouse.x = mouse.y = -9999; });
    }
    if (mode === 'ambient') {
      host.addEventListener('pointerdown', function (e) {
        if (e.target.closest('a,button,input')) return;
        var r = cv.getBoundingClientRect();
        for (var i = 0; i < 26; i++) spawn(e.clientX - r.left, e.clientY - r.top, true);
        tick();
      });
    }
    if (mode === 'burst') {
      window.addEventListener('maithri:burst', function (e) {
        var r = cv.getBoundingClientRect(), d = e.detail;
        for (var i = 0; i < (d.n || 30); i++) spawn(d.x - r.left, d.y - r.top, true);
        tick();
      });
    }
    function tick() { if (!running) { running = true; requestAnimationFrame(loop); } }
    function loop() {
      t += 0.016;
      ctx.clearRect(0, 0, w, h);
      var on = FX.sparks && FX.motion;
      if (on && active && mode !== 'burst') {
        var target = mode === 'hover' ? 26 : Math.round(FX.density * (w * h) / (1280 * 700));
        var amb = 0; for (var k = 0; k < P.length; k++) if (!P[k].burst) amb++;
        if (amb < target) for (var s = 0; s < Math.min(3, target - amb); s++) spawn();
      }
      for (var i = P.length - 1; i >= 0; i--) {
        var p = P[i]; p.life++;
        if (p.burst) { p.vx *= 0.955; p.vy = p.vy * 0.955 + 0.035; } else { p.vx += Math.sin(t * 1.3 + p.ph) * 0.012; }
        var dx = p.x - mouse.x, dy = p.y - mouse.y, d2 = dx * dx + dy * dy;
        if (d2 < 12100) { var d = Math.sqrt(d2) + 0.001, f = (1 - d / 110) * 1.4; p.x += dx / d * f; p.y += dy / d * f; p.glow = 1; }
        p.x += p.vx; p.y += p.vy;
        if (p.life > p.max || p.y < -20 || !on) { P.splice(i, 1); continue; }
        var kk = p.life / p.max, a = Math.sin(Math.PI * Math.min(1, kk)) * (0.6 + 0.4 * Math.sin(t * 5 + p.ph * 7));
        if (p.glow) { a = Math.min(1, a * 1.6); p.glow *= 0.94; }
        var sz = p.r * 7 * (p.glow ? 1 + p.glow * 0.6 : 1);
        ctx.globalAlpha = a; ctx.drawImage(sprite(p.c), p.x - sz / 2, p.y - sz / 2, sz, sz);
        if (p.star) drawStar(ctx, p.x, p.y, p.r * 1.4, p.c, a);
      }
      ctx.globalAlpha = 1;
      var keep = (visible || mode === 'burst') && (P.length || (on && active && mode !== 'burst'));
      if (keep) requestAnimationFrame(loop); else running = false;
    }
    tick();
  }

  function sparkBurst(src, n) {
    if (!FX.sparks || !FX.motion || !src) return;
    var x, y;
    if (src.getBoundingClientRect && !('clientX' in src)) { var r = src.getBoundingClientRect(); x = r.left + r.width / 2; y = r.top + r.height / 2; }
    else if ('clientX' in src) { x = src.clientX; y = src.clientY; }
    else return;
    window.dispatchEvent(new CustomEvent('maithri:burst', { detail: { x: x, y: y, n: n || 30 } }));
  }
  M.sparkBurst = sparkBurst;

  /* ---------------- Tilt ---------------- */
  function initTilt(el) {
    el.addEventListener('pointermove', function (e) {
      var m = FX.motion ? FX.tilt : 0;
      if (e.pointerType !== 'mouse' || !m) return;
      var r = el.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      el.style.setProperty('--ry', ((px - 0.5) * 2 * m).toFixed(2) + 'deg');
      el.style.setProperty('--rx', (-(py - 0.5) * 2 * m).toFixed(2) + 'deg');
      el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
      el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      el.classList.add('tilting');
    });
    el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); el.classList.remove('tilting'); });
  }

  /* ---------------- Reveals ---------------- */
  var revealIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function initReveal(el) {
    if (!FX.motion || M.designMode || !revealIO) { el.classList.add('in'); return; }
    revealIO.observe(el);
  }

  /* ---------------- Hero parallax ---------------- */
  function initHero(sec) {
    var frame = sec.querySelector('[data-hero-frame]'); if (!frame) return;
    sec.addEventListener('pointermove', function (e) {
      if (!FX.motion || e.pointerType !== 'mouse') return;
      var r = sec.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5, m = FX.tilt / 10;
      frame.style.transform = 'perspective(1400px) rotateY(' + (px * 6 * m) + 'deg) rotateX(' + (-py * 4 * m) + 'deg) scale(1.02)';
    });
    sec.addEventListener('pointerleave', function () { frame.style.transform = ''; });
  }

  /* ---------------- Find your need ---------------- */
  function initNeeds(sec) {
    var rows = sec.querySelectorAll('[data-need-row]'), stage = sec.querySelector('[data-need-stage]');
    function set(i) {
      rows.forEach(function (r) { r.classList.toggle('on', r.getAttribute('data-need-row') === String(i)); });
      if (!stage) return;
      stage.querySelectorAll('[data-need-img]').forEach(function (im) {
        var on = im.getAttribute('data-need-img') === String(i);
        if (on && !im.classList.contains('on')) stage.style.setProperty('--c', im.getAttribute('data-color'));
        im.classList.toggle('on', on);
      });
    }
    rows.forEach(function (r) {
      var i = r.getAttribute('data-need-row');
      r.addEventListener('mouseenter', function () { set(i); });
      r.addEventListener('click', function () { set(i); });
    });
  }

  /* ---------------- Product ---------------- */
  function initProduct(sec) {
    // gallery
    var slides = sec.querySelectorAll('[data-slide]'), thumbs = sec.querySelectorAll('[data-thumb]');
    function show(i) {
      slides.forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-slide') === String(i)); });
      thumbs.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-thumb') === String(i)); });
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-thumb')); }); });

    var form = sec.querySelector('[data-product-form]'); if (!form) return;
    var input = form.querySelector('[data-variant-input]');
    var qtyIn = form.querySelector('[data-qty-input]');
    var addBtn = form.querySelector('[data-add-button]'), addText = form.querySelector('[data-add-text]');
    var priceNow = sec.querySelector('[data-price-now]'), priceMrp = sec.querySelector('[data-price-mrp]');
    var offerTag = sec.querySelector('[data-offer-tag]'), offerPct = sec.querySelector('[data-offer-pct]');
    var label = addBtn ? addBtn.getAttribute('data-label') : 'Add to bag';
    var current = null;

    function qty() { return Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1); }
    function render(v) {
      current = v;
      if (!v) { if (addBtn) addBtn.disabled = true; if (addText) addText.textContent = M.strings.unavailable; return; }
      input.value = v.id;
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      var has = v.compare > v.price;
      if (priceMrp) { priceMrp.hidden = !has; if (has) priceMrp.textContent = formatMoney(v.compare); }
      if (offerTag) { offerTag.hidden = !has; if (has && offerPct) offerPct.textContent = Math.round((1 - v.price / v.compare) * 100); }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? label + ' · ' + formatMoney(v.price * qty()) : M.strings.soldOut;
      if (window.history && window.history.replaceState && !M.designMode) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
    }

    // single-option size cards
    var sizes = form.querySelectorAll('.size[data-variant-id]');
    function fromBtn(b) { return { id: b.getAttribute('data-variant-id'), price: +b.getAttribute('data-price'), compare: +b.getAttribute('data-compare'), available: b.getAttribute('data-available') === 'true' }; }
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        sizes.forEach(function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        render(fromBtn(b));
      });
      if (b.classList.contains('on')) current = fromBtn(b);
    });

    // multi-option selects
    var json = sec.querySelector('[data-variants-json]');
    if (json) {
      var variants = JSON.parse(json.textContent);
      var selects = form.querySelectorAll('[data-option-index]');
      var pick = function () {
        var vals = Array.prototype.map.call(selects, function (s) { return s.value; });
        render(variants.find(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); }) || null);
      };
      selects.forEach(function (s) { s.addEventListener('change', pick); });
      current = variants.find(function (v) { return String(v.id) === String(input.value); }) || null;
    }

    // quantity
    var minus = form.querySelector('[data-qty-minus]'), plus = form.querySelector('[data-qty-plus]');
    function setQty(n) { qtyIn.value = Math.max(1, n); if (current) render(current); }
    if (minus) minus.addEventListener('click', function () { setQty(qty() - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(qty() + 1); });
    if (qtyIn) qtyIn.addEventListener('change', function () { setQty(qty()); });

    // add to cart
    form.addEventListener('submit', function (e) {
      if (M.cartType === 'page') return;
      if (e.submitter && e.submitter.closest && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      if (addBtn) { addBtn.disabled = true; sparkBurst(addBtn, 40); }
      var fd = new FormData(form);
      fetch(M.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (item) {
          var name = sec.querySelector('.pdp-info .pill');
          toast((name ? name.textContent.trim().replace(/\b\w+/g, function (w) { return w.charAt(0) + w.slice(1).toLowerCase(); }) : item.product_title) + ' ' + M.strings.added);
          return refreshCart(true);
        })
        .catch(function (err) { toast((err && (err.description || err.message)) || M.strings.error); })
        .then(function () { if (addBtn && current) addBtn.disabled = !current.available; });
    });
  }

  /* ---------------- Cart drawer ---------------- */
  function drawerEl() { return document.querySelector('[data-cart-drawer]'); }
  function openCart() {
    document.body.classList.add('drawer-open');
    var d = drawerEl(); if (d) setTimeout(function () { d.focus({ preventScroll: true }); }, 50);
  }
  function closeCart() { document.body.classList.remove('drawer-open'); }
  M.openCart = openCart; M.closeCart = closeCart;

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.textContent = n; c.classList.add('bump'); setTimeout(function () { c.classList.remove('bump'); }, 350);
    });
  }
  function refreshCart(open) {
    var d = drawerEl(); if (d) d.classList.add('loading');
    return Promise.all([
      fetch(M.routes.root.replace(/\/$/, '') + '/?section_id=cart-drawer').then(function (r) { return r.text(); }),
      fetch(M.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var doc = new DOMParser().parseFromString(res[0], 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer]'), cur = drawerEl();
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      updateCount(res[1].item_count);
      var bag = document.getElementById('bag-btn');
      if (bag) setTimeout(function () { sparkBurst(bag, 22); }, 250);
      if (open) setTimeout(openCart, 300);
    }).catch(function () { if (open) window.location.href = M.routes.cart; })
      .then(function () { var d2 = drawerEl(); if (d2) d2.classList.remove('loading'); });
  }
  function changeLine(line, q) {
    var d = drawerEl(); if (d) d.classList.add('loading');
    return fetch(M.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(q, 10)) })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; }); })
      .catch(function (e) { toast((e && e.description) || M.strings.error); })
      .then(function () { return refreshCart(false); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-cart-open]');
    if (opener && M.cartType !== 'page' && !document.body.classList.contains('template-cart')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    if (t.closest('[data-cart-close-link]')) { closeCart(); return; }
    var ch = t.closest('[data-change]');
    if (ch && ch.closest('[data-cart-drawer]')) { e.preventDefault(); changeLine(ch.getAttribute('data-change'), ch.getAttribute('data-qty')); return; }
    var sp = t.closest('[data-spark-click]');
    if (sp) sparkBurst(e, parseInt(sp.getAttribute('data-spark-count') || '28', 10));
    var themeBtn = t.closest('[data-theme-set]');
    if (themeBtn) setTheme(themeBtn.getAttribute('data-theme-set'));
    var menuBtn = t.closest('[data-menu-toggle]');
    if (menuBtn) {
      var hd = menuBtn.closest('[data-header]'), open = !hd.classList.contains('menu-open');
      hd.classList.toggle('menu-open', open); menuBtn.setAttribute('aria-expanded', open);
      return;
    }
    if (t.closest('.site-header nav a')) { var h2 = t.closest('[data-header]'); if (h2) h2.classList.remove('menu-open'); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------------- Toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('Toast'); if (!el) return;
    el.textContent = msg; el.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2600);
  }
  M.toast = toast;

  /* ---------------- Ivory / Sanctum ---------------- */
  function syncThemeButtons() {
    var cur = document.documentElement.getAttribute('data-theme') === 'sanctum' ? 'sanctum' : 'light';
    document.querySelectorAll('[data-theme-set]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-theme-set') === cur); });
  }
  function setTheme(v) {
    if (v === 'sanctum') document.documentElement.setAttribute('data-theme', 'sanctum');
    else document.documentElement.removeAttribute('data-theme');
    try { localStorage.setItem('maithri-theme', v); } catch (e) {}
    syncThemeButtons();
  }

  /* ---------------- Init ---------------- */
  function init(root) {
    root = root || document;
    root.querySelectorAll('canvas[data-spark]:not([data-ready])').forEach(function (c) { c.setAttribute('data-ready', ''); try { SparkField(c); } catch (e) {} });
    root.querySelectorAll('.tilt:not([data-tilt-ready])').forEach(function (el) { el.setAttribute('data-tilt-ready', ''); initTilt(el); });
    root.querySelectorAll('.reveal:not(.in)').forEach(initReveal);
    root.querySelectorAll('[data-hero-tilt]:not([data-ready])').forEach(function (s) { s.setAttribute('data-ready', ''); initHero(s); });
    root.querySelectorAll('[data-needs]:not([data-ready])').forEach(function (s) { s.setAttribute('data-ready', ''); initNeeds(s); });
    root.querySelectorAll('[data-product-section]:not([data-ready])').forEach(function (s) { s.setAttribute('data-ready', ''); initProduct(s); });
    syncThemeButtons();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.id && e.target.id.indexOf('cart-drawer') > -1) openCart();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.id && e.target.id.indexOf('cart-drawer') > -1) closeCart();
  });
})();
